module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "min-width": "600",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-details": "",
      "xpersistent": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.goToElementMaintenance
    }
  }, [_c('v-list-item-title', [_vm._v("Maintenance")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "element-title-bar"
  }, [_vm._v(_vm._s(_vm.model.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Details'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Details'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Details")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Advanced'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Advanced'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("category")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Advanced")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Display'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Display'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("visibility")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Display")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Filters'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Filters'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("blur_linear")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Filters")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Tasks'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Tasks'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("dns")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Tasks")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [(_vm.tab == 'Details') ? [(!_vm.typeHasValue) ? _c('v-select', {
    attrs: {
      "items": _vm.typeOptions,
      "label": "Type"
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    ref: "focus",
    attrs: {
      "label": "Title"
    },
    on: {
      "blur": _vm.setDefaultName
    },
    model: {
      value: (_vm.model.title),
      callback: function($$v) {
        _vm.$set(_vm.model, "title", $$v)
      },
      expression: "model.title"
    }
  }), _vm._v(" "), (_vm.model.type == 'Text') ? _c('v-checkbox', {
    attrs: {
      "label": "Multi-line"
    },
    model: {
      value: (_vm.model.multiLine),
      callback: function($$v) {
        _vm.$set(_vm.model, "multiLine", $$v)
      },
      expression: "model.multiLine"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('Value')) ? _c('v-textarea', {
    attrs: {
      "label": "Value",
      "rows": 3
    },
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.type == 'List' || _vm.model.type == 'Options' || _vm.model.type == 'Status') ? _c('v-text-field', {
    ref: "optionsText",
    attrs: {
      "label": "Options"
    },
    model: {
      value: (_vm.model.options),
      callback: function($$v) {
        _vm.$set(_vm.model, "options", $$v)
      },
      expression: "model.options"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.type == 'List') ? _c('v-checkbox', {
    attrs: {
      "label": "Allow custom text"
    },
    model: {
      value: (_vm.model.allowCustomText),
      callback: function($$v) {
        _vm.$set(_vm.model, "allowCustomText", $$v)
      },
      expression: "model.allowCustomText"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nameHasValue) ? _c('v-text-field', {
    attrs: {
      "label": "Field Name"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.type == 'Tab') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Button') ? [_c('v-select', {
    attrs: {
      "items": _vm.buttonActionOptions,
      "label": "Button Action"
    },
    model: {
      value: (_vm.model.buttonAction),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonAction", $$v)
      },
      expression: "model.buttonAction"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.buttonElementsOptions,
      "label": "Elements Affected"
    },
    model: {
      value: (_vm.model.buttonElements),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonElements", $$v)
      },
      expression: "model.buttonElements"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "How many"
    },
    model: {
      value: (_vm.model.buttonElementCount),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonElementCount", $$v)
      },
      expression: "model.buttonElementCount"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.buttonIconOptions,
      "label": "Button Icon",
      "clearable": ""
    },
    model: {
      value: (_vm.model.buttonIcon),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonIcon", $$v)
      },
      expression: "model.buttonIcon"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Blue"
    },
    model: {
      value: (_vm.model.primary),
      callback: function($$v) {
        _vm.$set(_vm.model, "primary", $$v)
      },
      expression: "model.primary"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Email') ? [_c('v-text-field', {
    attrs: {
      "label": "Email Template Group"
    },
    model: {
      value: (_vm.model.emailGroup),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailGroup", $$v)
      },
      expression: "model.emailGroup"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email Template Name"
    },
    model: {
      value: (_vm.model.emailName),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailName", $$v)
      },
      expression: "model.emailName"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "clearable": "",
      "label": "Send to Role"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Message when completed"
    },
    model: {
      value: (_vm.model.completeMessage),
      callback: function($$v) {
        _vm.$set(_vm.model, "completeMessage", $$v)
      },
      expression: "model.completeMessage"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Send to Field"
    },
    model: {
      value: (_vm.model.toField),
      callback: function($$v) {
        _vm.$set(_vm.model, "toField", $$v)
      },
      expression: "model.toField"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'SMS') ? [_c('v-text-field', {
    attrs: {
      "label": "Message"
    },
    model: {
      value: (_vm.model.message),
      callback: function($$v) {
        _vm.$set(_vm.model, "message", $$v)
      },
      expression: "model.message"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Send to Role"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Contact Selector') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Role",
      "chips": ""
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Contact') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Role"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'User Chooser') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Role",
      "chips": ""
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Lookup') ? [_c('v-text-field', {
    attrs: {
      "label": "Lookup Path",
      "hint": "eg. [lender]/[broker]/Broker Id"
    },
    model: {
      value: (_vm.model.lookup),
      callback: function($$v) {
        _vm.$set(_vm.model, "lookup", $$v)
      },
      expression: "model.lookup"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Show in Help Panel",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.help),
      callback: function($$v) {
        _vm.$set(_vm.model, "help", $$v)
      },
      expression: "model.help"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Global",
      "hint": "All users share accross the system"
    },
    model: {
      value: (_vm.model.global),
      callback: function($$v) {
        _vm.$set(_vm.model, "global", $$v)
      },
      expression: "model.global"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Widget') ? [_c('v-select', {
    attrs: {
      "items": _vm.widgetOptions,
      "label": "Which Widget"
    },
    model: {
      value: (_vm.model.widget),
      callback: function($$v) {
        _vm.$set(_vm.model, "widget", $$v)
      },
      expression: "model.widget"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": [1, 2],
      "label": "Widget Version"
    },
    model: {
      value: (_vm.model.version),
      callback: function($$v) {
        _vm.$set(_vm.model, "version", $$v)
      },
      expression: "model.version"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Scheduler') ? [_c('v-combobox', {
    attrs: {
      "items": ['1', '2', '3', '4', '5', '6', '7', '10', '14', '21'],
      "label": "Days till follow up"
    },
    model: {
      value: (_vm.model.days),
      callback: function($$v) {
        _vm.$set(_vm.model, "days", $$v)
      },
      expression: "model.days"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Task Text"
    },
    model: {
      value: (_vm.model.taskText),
      callback: function($$v) {
        _vm.$set(_vm.model, "taskText", $$v)
      },
      expression: "model.taskText"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Assign to Role",
      "hint": "Leave blank for current user"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Charge') ? [_c('CurrencyBox', {
    attrs: {
      "label": "Amount"
    },
    model: {
      value: (_vm.model.amount),
      callback: function($$v) {
        _vm.$set(_vm.model, "amount", $$v)
      },
      expression: "model.amount"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Date') ? [_c('v-switch', {
    attrs: {
      "label": "Short Format",
      "color": "primary"
    },
    model: {
      value: (_vm.model.short),
      callback: function($$v) {
        _vm.$set(_vm.model, "short", $$v)
      },
      expression: "model.short"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Relative to Another Date")]), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Source Element Name",
      "items": _vm.dateElementNames,
      "clearable": ""
    },
    model: {
      value: (_vm.model.relativeTo),
      callback: function($$v) {
        _vm.$set(_vm.model, "relativeTo", $$v)
      },
      expression: "model.relativeTo"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Html') ? [_c('v-textarea', {
    attrs: {
      "label": "Html to Display"
    },
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Jump') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.elementNames,
      "label": "Jump to Element"
    },
    model: {
      value: (_vm.model.target),
      callback: function($$v) {
        _vm.$set(_vm.model, "target", $$v)
      },
      expression: "model.target"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'File') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'File Upload') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Target File Name"
    },
    model: {
      value: (_vm.model.targetName),
      callback: function($$v) {
        _vm.$set(_vm.model, "targetName", $$v)
      },
      expression: "model.targetName"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Outstanding') ? [_c('v-textarea', {
    attrs: {
      "rows": 3,
      "label": "Outstanding Item"
    },
    model: {
      value: (_vm.model.text),
      callback: function($$v) {
        _vm.$set(_vm.model, "text", $$v)
      },
      expression: "model.text"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": 3,
      "label": "Response"
    },
    model: {
      value: (_vm.model.response),
      callback: function($$v) {
        _vm.$set(_vm.model, "response", $$v)
      },
      expression: "model.response"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.statusOptions,
      "label": "Status"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Exporter') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type != 'Tab') ? _c('v-slider', {
    attrs: {
      "label": ("Width (" + (_vm.model.width) + "%)"),
      "step": 10
    },
    model: {
      value: (_vm.model.width),
      callback: function($$v) {
        _vm.$set(_vm.model, "width", $$v)
      },
      expression: "model.width"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.tab == 'Advanced') ? _c('div', {
    staticStyle: {
      "height": "600px"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.typeOptions,
      "label": "Element Type"
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field Name"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Used in dashboards",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.dashboards),
      callback: function($$v) {
        _vm.$set(_vm.model, "dashboards", $$v)
      },
      expression: "model.dashboards"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Locked",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.locked),
      callback: function($$v) {
        _vm.$set(_vm.model, "locked", $$v)
      },
      expression: "model.locked"
    }
  }), _vm._v(" "), (_vm.model.type == 'Switch' || _vm.model.type == 'Slider') ? _c('v-checkbox', {
    attrs: {
      "label": "Label on Top",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.labelTop),
      callback: function($$v) {
        _vm.$set(_vm.model, "labelTop", $$v)
      },
      expression: "model.labelTop"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Milestone",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.milestone),
      callback: function($$v) {
        _vm.$set(_vm.model, "milestone", $$v)
      },
      expression: "model.milestone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Transaction Field"
    },
    model: {
      value: (_vm.model.transactionField),
      callback: function($$v) {
        _vm.$set(_vm.model, "transactionField", $$v)
      },
      expression: "model.transactionField"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.clearValue
    }
  }, [_vm._v("Clear Value")])], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 'Display') ? _c('div', [(_vm.isContainer) ? _c('v-checkbox', {
    attrs: {
      "label": "Reverse Items",
      "hint": "Shows elements in reverse order",
      "hide-details": "",
      "xpersistent-hint": ""
    },
    model: {
      value: (_vm.model.reverse),
      callback: function($$v) {
        _vm.$set(_vm.model, "reverse", $$v)
      },
      expression: "model.reverse"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Compact",
      "hint": "Takes up less space",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.compact),
      callback: function($$v) {
        _vm.$set(_vm.model, "compact", $$v)
      },
      expression: "model.compact"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Hide Heading",
      "hint": "Takes up less space",
      "hide-details": "",
      "xpersistent-hint": ""
    },
    model: {
      value: (_vm.model.hideHeading),
      callback: function($$v) {
        _vm.$set(_vm.model, "hideHeading", $$v)
      },
      expression: "model.hideHeading"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Show Hint",
      "hint": "Shows in expanded mode",
      "hide-details": "",
      "xpersistent-hint": ""
    },
    model: {
      value: (_vm.model.showHint),
      callback: function($$v) {
        _vm.$set(_vm.model, "showHint", $$v)
      },
      expression: "model.showHint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Collapsable",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.collapsable),
      callback: function($$v) {
        _vm.$set(_vm.model, "collapsable", $$v)
      },
      expression: "model.collapsable"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Don't Print",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.dontPrint),
      callback: function($$v) {
        _vm.$set(_vm.model, "dontPrint", $$v)
      },
      expression: "model.dontPrint"
    }
  }), _vm._v(" "), (_vm.model.order) ? _c('v-text-field', {
    attrs: {
      "label": "Sort Order",
      "disabled": ""
    },
    model: {
      value: (_vm.model.order),
      callback: function($$v) {
        _vm.$set(_vm.model, "order", $$v)
      },
      expression: "model.order"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 'Formula') ? _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Value"
    },
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Result",
      "hide-details": ""
    },
    model: {
      value: (_vm.formulaResult),
      callback: function($$v) {
        _vm.formulaResult = $$v
      },
      expression: "formulaResult"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 'Filters') ? _c('div', [(!this.filterArray.length) ? _c('div', [_vm._v("\n                    No Filters\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterArray), function(filter) {
    return _c('div', {
      key: filter.name,
      staticClass: "action-panel"
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "50px",
        "padding": "8px"
      }
    }, [_c('v-icon', [_vm._v("visibility")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding": "8px"
      }
    }, [_vm._v("\n                        " + _vm._s(filter.type) + " when "), _c('b', [_vm._v(_vm._s(filter.name))]), _vm._v(" " + _vm._s(filter.operator.toLowerCase()) + ": '" + _vm._s(filter.values.join('/')) + "'\n                    ")]), _vm._v(" "), _c('div', [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "ripple": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "grey lighten-1"
            }
          }, [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editFilter(filter)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit Filter")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteFilter(filter)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Filter")])], 1)], 1)], 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    on: {
      "click": _vm.addFilter
    }
  }, [_vm._v("Add Filter")])], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.tab == 'Tasks') ? _c('div', [_c('div', {
    staticClass: "small-text",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_vm._v("Automatic tasks can be added to your task list when input for this element is completed.")]), _vm._v(" "), _c('v-list', {
    staticClass: "selectable",
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_vm._l(((_vm.model.tasks || [])), function(task, taskIndex) {
    return _c('v-list-item', {
      key: taskIndex,
      class: {
        active: task == _vm.editingTask
      },
      on: {
        "click": function($event) {
          _vm.editingTask = task
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("dns")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(task.title)
      }
    }), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(task.assigned) + " in " + _vm._s(task.days) + " days")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteAutomaticTask(task)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.addAutomaticTask
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add an automatic task")])], 1), _vm._v(" "), _c('v-list-item-action')], 1)], 2), _vm._v(" "), (_vm.editingTask) ? [_c('div', {
    staticClass: "section"
  }, [_vm._v("Task Details")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Task Text"
    },
    model: {
      value: (_vm.editingTask.title),
      callback: function($$v) {
        _vm.$set(_vm.editingTask, "title", $$v)
      },
      expression: "editingTask.title"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Assign to Role"
    },
    model: {
      value: (_vm.editingTask.role),
      callback: function($$v) {
        _vm.$set(_vm.editingTask, "role", $$v)
      },
      expression: "editingTask.role"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": ['1', '2', '3', '4', '5', '6', '7', '10', '14', '21'],
      "label": "Days"
    },
    model: {
      value: (_vm.editingTask.days),
      callback: function($$v) {
        _vm.$set(_vm.editingTask, "days", $$v)
      },
      expression: "editingTask.days"
    }
  })] : _vm._e()], 2) : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [
    [(this.model.key) ? _c('DeleteButton', {
      staticStyle: {
        "float": "left"
      },
      on: {
        "delete": _vm.deleteElement
      }
    }) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.cancel($event)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "disabled": !_vm.valid
      },
      nativeOn: {
        "click": function($event) {
          return _vm.save($event)
        }
      }
    }, [_vm._v("Save")])]
  ], 2)])]), _vm._v(" "), _c('FilterEditor', {
    attrs: {
      "settings": _vm.filterEditorDialog.settings,
      "elements": _vm.filterEditorDialog.elements,
      "filterProp": _vm.filterEditorDialog.filter
    },
    on: {
      "save": _vm.saveFilter,
      "delete": _vm.deleteFilter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ed90ad5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ElementDialog.vue
// module id = 2572
// module chunks = 1